import * as R from "ramda";

import {
	notificationsRoutes,
	notificationsContent,
} from "@/constants/notifications";

const valueFrom = R.flip(R.prop);

export const sortNotificationsByPriority = R.sortBy(R.prop("sortOrder"));

export const pathForNotification = R.compose((notification) => {
	const n = R.defaultTo({})(notification);
	const typename = R.prop("__typename", n);
	const routes = notificationsRoutes({ id: n.id });
	const path = routes[typename];
	return path || null;
});

export const contentForNotification = R.compose(
	R.defaultTo(null),
	valueFrom(notificationsContent),
	R.prop("__typename"),
	R.defaultTo({}),
);
